<template>
  <span>
    <router-link :to="{ name: 'journal' }" class="text-muted">
      <i class="material-icons">date_range</i>
    </router-link>
    <router-link :to="{ name: 'project_journal' }" class="text-muted">
      <i class="material-icons">work</i>
    </router-link>
    <router-link :to="{ name: 'contact_journal' }" class="text-muted">
      <i class="material-icons">contacts</i>
    </router-link>
    <router-link :to="{ name: 'tag_journal' }" class="text-muted">
      <i class="material-icons">label_outline</i>
    </router-link>
    <TaskExpander />
  </span>
</template>

<script>
import TaskExpander from "components/TaskExpander";

export default {
  components: {
    TaskExpander
  }
};
</script>
